<script setup>
import HighlightableField from "@/components/projects/HighlightableField/HighlightableField";

defineProps({
  project: {
    type: Object,
    required: true,
  },
  candidate: {
    type: Object,
    required: true,
  },
  certification: {
    type: Object,
    required: true,
  },
  tokensEnabled: {
    type: Boolean,
    default: false,
  },
});

const formatCertification = (cert) => {
  if (!cert) return "";

  const parts = [];
  if (cert.certificationName) parts.push(cert.certificationName);
  if (cert.institutionName) parts.push(cert.institutionName);

  return parts.join(" • ");
};
</script>

<template>
  <div class="mb-4 certification-item">
    <HighlightableField
      v-if="certification.certificationName || certification.institutionName"
      :enabled="tokensEnabled"
      :project="project"
      :candidate="candidate"
      :token-text="formatCertification(certification)"
      token-type="plain"
      :additional-token-types="['plain']"
      :similarity-tokens="[]"
    />

    <span v-if="certification.time" class="date-label">
      ({{ certification.time }})
    </span>
  </div>
</template>

<style scoped lang="scss">
.certification-item {
  color: $tf-font-default;

  .date-label {
    color: $tf-font-ghost;
    margin-left: 4px;
  }
}
</style>

